<template>
  <main
    class="main-layout"
    :class="{
      webview: environment.isMobileApp,
      isReacting,
    }"
  >
    <slot />
  </main>
</template>

<script setup lang="ts">
import { useComputedValue } from "@/composables";
import { GetterTypes } from "@/store";
import { AppEnvironment } from "@/store/app/state";
import { computed } from "vue";
const messageReactionId = useComputedValue<string | null>(
  GetterTypes.GET_MESSAGE_REACTION_ID,
);
const environment = useComputedValue<AppEnvironment>(
  GetterTypes.GET_APP_ENVIRONMENT,
);
const isReacting = computed(() => !!messageReactionId.value);
</script>

<style lang="scss" scoped>
@import "src/assets/scss/layout/mainLayout";
</style>
